import { useSelector } from "react-redux";

import { selectCurrentUser } from "@/redux/authentication/selectors";

/**
 * Returns the active organization ID for the current user.
 */
export const useOrganizationId = (): number | null => {
  const currentUser = useSelector(selectCurrentUser);
  return currentUser?.organization?.id ?? null;
};
